import styled from 'styled-components'
import { Collapse } from 'antd'
import { isMobile } from 'react-device-detect'
import { greys, font } from 'assets/themes/theme-default'

const AntCollapseStyled = styled(Collapse)`
  &&& {
    .ant-collapse-item > .ant-collapse-header {
      color: ${greys.dark1};
      font-weight: ${font.weight.base};
      background: ${greys.light4};
      border-radius:  0;
      font-size: ${font.size.lgxxs};
      word-break: break-word;
      // padding: ${isMobile && '5px 0'};
      .ant-collapse-arrow {
        color: ${props => props.theme.colors.color1.bg};
        font-size: ${font.size.lgxxs};
      }
    }

    .ant-collapse-item-active.ant-collapse-item {
      .ant-collapse-header {
        fill:${props => props.theme.colors.color1.bg};
        border-color: ${props => props.theme.colors.color1.bg};
        color: ${props => props.theme.colors.color1.bg};
      }
    }

    &.ant-collapse-borderless > .ant-collapse-item {
      border-color: ${greys.dark3};
      > .ant-collapse-content{
        background-color: ${greys.light4};
      }
    }
    
  }
`
export default AntCollapseStyled
